export interface ServiceAccountApiResponse {
  name: string;
  uid: string;
  displayName: string;
  description?: string;
  username: string;
  enabled: boolean;
  createTime?: string;
  updateTime?: string;
  etag?: string;
}

export interface ServiceAccount extends ServiceAccountApiResponse {
  locations: number;
  auth: number;
  deliveries: number;
}

export const transformServiceAccount = (apiAccount: ServiceAccountApiResponse): ServiceAccount => ({
  ...apiAccount,
  locations: 0,
  auth: 0,
  deliveries: 0,
});

export interface CreateServiceAccountRequest {
  serviceAccount: Omit<ServiceAccountApiResponse, 'uid' | 'createTime' | 'updateTime'>;
  password: string;
  serviceAccountId?: string;
}

export interface UpdateServiceAccountRequest {
  serviceAccount: Partial<ServiceAccountApiResponse> & { name: string };
  updateMask?: string[];
}

export interface ListServiceAccountsParams {
  pageSize?: number;
  pageToken?: string;
  filter?: string;
  orderBy?: string;
}

export interface ListServiceAccountsResponse {
  serviceAccounts: ServiceAccount[];
  nextPageToken?: string;
  totalSize: number;
}

export interface RotatePasswordRequest {
  name: string;
  newPassword: string;
}

export interface RotatePasswordResponse {
  success: boolean;
}

export interface EnableServiceAccountResponse {
  serviceAccount: ServiceAccount;
}

export interface DisableServiceAccountResponse {
  serviceAccount: ServiceAccount;
}
